import { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import IgniteDataTable from '../common/datatable';
import { dateFormat } from '../../utils/commonFunctions';

class PersonalRewardsStatementList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      delete: {
        show: false
      }
    };
  }

  render() {
    const columns = [
      {
        prop: 'created-at', title: 'Date', width: '100', format(data) { return dateFormat(data); }
      },
      {
        prop: 'store', title: 'Store', width: '100', format(data, row) { return row.attributes['is-hidden'] ? '' : data; }
      },
      {
        prop: 'description',
        title: 'Description',
        width: '270',
        format: data => (<div style={ { whiteSpace: 'normal' } }>{data}</div>)
      },
      {
        prop: 'value', title: 'Value', width: '100', format(data) { return <b>{data}</b>; }
      },
      {
        prop: 'balance', title: 'Balance', width: '100', format(data) { return <b>{data}</b>; }
      },
    ];

    const columnsMobile = [
      {
        prop: 'transaction',
        title: 'Transaction',
        format(data, row) {
          const balanceClass = +row.attributes.balance > 0 ? 'm-transaction-balance positive' : 'm-transaction-balance negative';

          return (
            <Container fluid>
              <Row>
                <Col xs={12}>
                  <div className="m-transaction-date">{dateFormat(row.attributes['created-at'])}</div>
                </Col>
              </Row>
              <Row>
                <Col xs={12} className="m-transactions-description">
                  {row.attributes.description}
                </Col>
              </Row>
              <Row>
                <Col xs={6}>
                  <div>Value: {row.attributes.value}</div>
                </Col>
                <Col xs={6}>
                  <div className={balanceClass}>Balance: {row.attributes.balance}</div>
                </Col>
              </Row>
            </Container>
          );
        }
      },
    ];

    return (
      this.props.points_statement && (
      <Row className="points-statement-tabs-personal-list-table">
        <Col className="d-none d-lg-block">
          <IgniteDataTable
            data={this.props.points_statement}
            dataSize={this.props.pagination.number * this.props.pagination.size}
            columns={columns}
            pagination={{
              onPageChange: this.props.onPageChange,
              page: this.props.currentPage
            }}
            remote
          />
        </Col>

        <Col className="d-block d-lg-none m-transactions">
          <IgniteDataTable
            data={this.props.points_statement}
            dataSize={this.props.pagination.number * this.props.pagination.size}
            columns={columnsMobile}
            pagination={{
              onPageChange: this.props.onPageChange,
              page: this.props.currentPage
            }}
            remote
          />
        </Col>
      </Row>
      ));
  }
}

export default connect()(PersonalRewardsStatementList);
